import React from "react";
import "./Fotos.css";
import FOTO1 from "../../assets/images/foto1.jpg";
import FOTO2 from "../../assets/images/foto2.jpg";
import FOTO3 from "../../assets/images/foto3.jpg";
import FOTO4 from "../../assets/images/foto4.jpg";

const Fotos = () => {
  const matchResult = window.matchMedia("(max-width:575px)").matches;

  return (
    <div className="fotos-container  p-5" id="fotos">
      <div className="container  d-flex justify-content-center">
        <div className="container-titulo-foto">
          <h2 className="text-center text-black titulo-foto" >Fotos Aéreas</h2>
        </div>
      </div>
      <div className={`container p-5 `}>
        <div
          className="row"
          style={{
            width: !matchResult ? "" : "150%",
            marginLeft: !matchResult ? "15px" : "-55px",
          }}
        >
          <div
            id="carouselExampleIndicators"
            className="carousel slide"
            data-ride="carousel"
          >
            <ol className="carousel-indicators">
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="0"
                className="active"
              ></li>
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="1"
              ></li>
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="2"
              ></li>
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="2"
              ></li>
            </ol>
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  className={`d-block  carousel-image ${
                    !matchResult ? "w-75" : "w-100 ml-0"
                  }`}
                  src={FOTO1}
                  alt="First slide"
                />
              </div>
              <div className="carousel-item">
                <img
                  className={`d-block  carousel-image ${
                    !matchResult ? "w-75" : "w-100 ml-0"
                  }`}
                  src={FOTO2}
                  alt="Second slide"
                />
              </div>
              <div className="carousel-item">
                <img
                  className={`d-block  carousel-image ${
                    !matchResult ? "w-75" : "w-100 ml-0"
                  }`}
                  src={FOTO3}
                  alt="Third slide"
                />
              </div>
              <div className="carousel-item">
                <img
                  className={`d-block  carousel-image ${
                    !matchResult ? "w-75" : "w-100 ml-0"
                  }`}
                  src={FOTO4}
                  alt="Fourd slide"
                />
              </div>
            </div>
            <a
              className="carousel-control-prev"
              href="#carouselExampleIndicators"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#carouselExampleIndicators"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fotos;
